import Axios from 'axios';
import * as appHelpers from '../../Utilities/appHelpers';
import { cloneDeep } from 'lodash';

const axiosInstance = Axios.create({
   baseURL: process.env.REACT_APP_BASE_API,
   //baseURL: 'https://qa-api.automedsys.net/emrapi/v1/',
   headers: {
      'Content-Type': 'application/json',
      'X-Correlation-ID': appHelpers.uuidv4(),
   },
});

axiosInstance.interceptors.request.use(async (config) => {
   const clonedConfig = cloneDeep(config);
   const token = appHelpers.getItemStore('AUTOMEDSYS_TOKEN');

   clonedConfig.headers.common = {
      Authorization: `Bearer ${token}`,
   };

   return clonedConfig;
});

const indicateActive = (res: any) => {
   const st = res.status === 401 ? 'force' : '1';
   //console.log(st);
   appHelpers.setItemStore('AUTOMEDSYS_ISACTIVE', st);

   return res;
};

axiosInstance.interceptors.response.use(indicateActive, (err) => {
   const errdata = err.response ? err.response : err;

   indicateActive(errdata);
   throw err;
});

export default axiosInstance;
